/////////////////////////////////////////////////////////////////////////////////////////////////////////
//FileName: discipline.js
//FileType: Javascript Source file
//Size : ?
//Author : Harun Durmuş
//Created On : 11.12.2020 14:51
//Last Modified On : ?
//Copy Rights : Oceannet
//Description : Catalog>Discipline Component
////////////////////////////////////////////////////////////////////////////////////////////////////////
import React from "react";
import { msalAuth } from "../../../../api/msal/MsalAuthProvider";
import $ from "jquery";
import Detail from "./Detail";
import Edit from "./Edit";
import Table from "./Table";
import AddDisciplineModal from "./modals/AddDisciplineModal";
import ColumnList from "../../../common/componet-jsons/column-list-catalog.json";
import Variable from "./variable/v";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as GC from "../../../common/common";

class Discipline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: props.token,
    };
  }

  async componentDidMount() {}

  render() {
    return (
      <div>
        <div className="border p-3 br5 full-width" id="border-mid">
          <Table {...this.props} />
          <Detail />
          <Edit />
          <AddDisciplineModal />

          <input hidden="true" id="e-identification" />
        </div>
      </div>
    );
  }
}

export default Discipline;
